import React, { useMemo, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { topicPages } from "../pages/topicPages";

const navLinkClass = ({ isActive }) =>
  `nav-link text-uppercase fw-bolder${isActive ? " active" : ""}`;

const resourceGroups = [
  {
    title: "Complaints",
    slugs: [
      "/findlay-chrysler-fraud",
      "/findlay-chrysler-lawsuit",
      "/findlay-chrysler-class-action-lawsuit",
      "/findlay-chrysler-class-action-process",
      "/findlay-chrysler-lawsuit-faq",
      "/findlay-chrysler-news-updates",
      "/findlay-chrysler-misleading-financials",
    ],
  },
  {
    title: "Reviews",
    slugs: [
      "/findlay-chrysler-complaints-reviews",
      "/findlay-chrysler-as-is-disclosure",
    ],
  },
  {
    title: "Trade-In",
    slugs: [
      "/findlay-chrysler-trade-in-issues",
      "/findlay-chrysler-complaint-documentation",
    ],
  },
  {
    title: "Inspection",
    slugs: [
      "/findlay-chrysler-inspection-checklist",
      "/findlay-chrysler-safety-system-failures",
    ],
  },
  {
    title: "Consumer Protection",
    slugs: [
      "/findlay-chrysler-consumer-protection",
    ],
  },
];

function SiteNav() {
  const pagesBySlug = useMemo(
    () => new Map(topicPages.map((page) => [page.slug, page])),
    []
  );
  const [navOpen, setNavOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleNavToggle = () => {
    setNavOpen((current) => {
      const next = !current;
      if (!next) {
        setOpenDropdown(null);
      }
      return next;
    });
  };

  const handleCollapse = () => {
    setNavOpen(false);
    setOpenDropdown(null);
  };

  const handleToggle = (title) => {
    setOpenDropdown((current) => (current === title ? null : title));
  };

  const handleClose = () => {
    setOpenDropdown(null);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container">
          <Link className="navbar-brand text-center text-uppercase fw-bolder" to="/">
            FindlayChryslers.com
          </Link>
          <button
            className={`navbar-toggler${navOpen ? "" : " collapsed"}`}
            type="button"
            aria-controls="navbarSupportedContent"
            aria-expanded={navOpen}
            aria-label="Toggle navigation"
            onClick={handleNavToggle}
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div
            className={`collapse navbar-collapse${navOpen ? " show" : ""}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink to="/" className={navLinkClass} end onClick={handleCollapse}>
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/guide" className={navLinkClass} onClick={handleCollapse}>
                  Buyer Guide
                </NavLink>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link text-uppercase fw-bolder"
                  href="https://www.ohioattorneygeneral.gov/individuals-and-families/consumers/file-a-complaint.aspx"
                  target="_blank"
                  rel="noreferrer"
                  onClick={handleCollapse}
                >
                  Report
                </a>
              </li>
              <li className="nav-item">
                <NavLink to="/legal" className={navLinkClass} onClick={handleCollapse}>
                  Legal
                </NavLink>
              </li>
              {resourceGroups.map((group) => {
                const menuId = `nav-${group.title
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")}`;
                const isOpen = openDropdown === group.title;

                return (
                  <li
                    className="nav-item dropdown"
                    key={group.title}
                    onMouseLeave={handleClose}
                  >
                    <button
                      type="button"
                      className={`nav-link dropdown-toggle text-uppercase fw-bolder${
                        isOpen ? " show" : ""
                      }`}
                      id={menuId}
                      aria-expanded={isOpen}
                      onClick={() => handleToggle(group.title)}
                      style={{ background: "transparent", border: 0 }}
                    >
                      {group.title}
                    </button>
                    <div
                      className={`dropdown-menu${isOpen ? " show" : ""}`}
                      aria-labelledby={menuId}
                    >
                      {group.slugs.map((slug) => {
                        const page = pagesBySlug.get(slug);
                        if (!page) {
                          return null;
                        }
                        return (
                          <Link
                            key={slug}
                            to={page.slug}
                            className="dropdown-item"
                            onClick={() => {
                              handleClose();
                              handleCollapse();
                            }}
                          >
                            {page.linkTitle || page.title}
                          </Link>
                        );
                      })}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default SiteNav;
